var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarClockFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29167 2.08334H9.375V4.16668H15.625V2.08334H17.7083V4.16668H20.8333C21.4086 4.16668 21.875 4.63305 21.875 5.20834V7.29168H3.125V5.20834C3.125 4.63305 3.59137 4.16668 4.16667 4.16668H7.29167V2.08334Z",
    fill: "#CD6EE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 8.85416H3.125V21.875C3.125 22.4503 3.59137 22.9167 4.16667 22.9167H15.4651C13.9716 21.6747 13.0208 19.8025 13.0208 17.7083C13.0208 13.9689 16.0522 10.9375 19.7917 10.9375C20.5185 10.9375 21.2187 11.052 21.875 11.2641V8.85416Z",
    fill: "#CD6EE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9999 17.7083C24.9999 20.5848 22.6681 22.9167 19.7916 22.9167C16.9151 22.9167 14.5833 20.5848 14.5833 17.7083C14.5833 14.8319 16.9151 12.5 19.7916 12.5C22.6681 12.5 24.9999 14.8319 24.9999 17.7083ZM20.5728 14.5833V17.9056L22.1669 19.4996L21.0621 20.6045L19.0103 18.5528V14.5833H20.5728Z",
    fill: "#CD6EE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarClockFill);
export default __webpack_public_path__ + "static/media/calendar_clock_fill.6150bcd6598660f4361e6ea13ae8a9c1.svg";
export { ForwardRef as ReactComponent };